import React from 'react';
import PropTypes from 'prop-types';
import { DisplayButton } from '@xo-union/tk-ui-links';
import styles from './styles.scss';

const ButtonDropdownItem = ({ children, onClick, closeDropdown, className, ...rest }) => {
  const handleClick = () => {
    onClick && onClick();
    closeDropdown();
  };

  return (
    <li tabIndex={0} className={styles.buttonDropdownItem}>
      <DisplayButton className={`${styles.itemLink} ${className || ''}`} onClick={handleClick} {...rest}>
        {children}
      </DisplayButton>
    </li>
  );
};

ButtonDropdownItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  closeDropdown: PropTypes.func,
  onClick: PropTypes.func,
};

export default ButtonDropdownItem;
